import React, { useRef } from "react";
import "./SharePage.css"; // We'll create this new CSS file below
import Alert from "./Alert"; // Adjust the path if CopiedAlert is in a different file

function SharePage({ result }) {
  const { medicationName, medicineImage, firstName, weightGoal, speedPreference, budget, injectionPreference, biggestChallenge, readinessLevel } = result;

  const alertRef = useRef(null);

  const quizURL = window.location.href; // Get the base URL of the quiz
  const shareMessage = `I just took this quiz and matched with ${medicationName}! Find out your match in 60 seconds!`;

  const encodeURL = (url) => encodeURIComponent(url);
  const encodeText = (text) => encodeURIComponent(text);

  const shareOnFacebook = () => {
    const urlToShare = `https://injectco.com/`;
    const messageForQuote = shareMessage;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?src=sp&u=${encodeURL(urlToShare)}&quote=${encodeText(messageForQuote)}`;

    window.open(facebookShareUrl, "_blank", "width=600,height=400");
  };

  const shareOnTwitter = () => {
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeText(shareMessage)}&url=${encodeURL(quizURL + "?utm_source=twitter&utm_medium=quiz_share")}`;
    window.open(twitterShareUrl, "_blank", "width=600,height=400");
  };

  const shareOnWhatsapp = () => {
    const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeText(shareMessage)}%20${encodeURL(quizURL + "?utm_source=whatsapp&utm_medium=quiz_share")}`;

    window.open(whatsappShareUrl, "_blank");
  };
  const copyLink = async () => {
    try {
      const textToCopy = window.location.href;
      await navigator.clipboard.writeText(textToCopy);
      if (alertRef.current) {
        alertRef.current.showAlert("Link copied!");
      }
    } catch (err) {
      console.error("Failed to copy link: ", err);
      alert("Failed to copy link. Please try again or copy manually.");
    }
  };

  return (
    <>
      <div className="logo-container">
        <img src="/assets/images/logo-white.png" alt="InjectCo Logo" className="logo-image" />
      </div>
      <div className="injectco-results-container">
        <main className="results-page-content">
          <div className="top-content">
            <div className="content-left">
              <div className="results-status-header">
                <h2>
                  {firstName}, based on your answers, your best match is {medicationName}
                </h2>
              </div>

              <section className="plan-details-section">
                <ul>
                  <li>
                    You're looking to lose <strong>{weightGoal}</strong>
                  </li>
                  <li>
                    You want to see <strong>{speedPreference}</strong> results
                  </li>
                  <li>
                    Your budget is <strong>{budget}</strong>
                  </li>
                  <li>
                    You're <strong>{injectionPreference}</strong>
                  </li>
                  <li>
                    Your biggest challenge is <strong>{biggestChallenge}</strong>
                  </li>
                  <li>
                    And you're <strong>{readinessLevel}</strong> to take control
                  </li>
                </ul>
              </section>
              <p className="results-page-intro">
                Based on this, we recommend {medicationName}, a science-backed treatment that's been shown in clinical trials to help patients lose up to <strong>15-22%</strong> of body weight while
                improving blood sugar, appetite, and energy levels.
              </p>
            </div>
            <div className="content-right">
              <img src={`/assets/images/${medicineImage}`} alt="Semaglutide Vial" className="vial_image" />
            </div>
          </div>

          <div className="next-steps">
            <h2>What Happens Next</h2>
            <p>You've got two ways to take the next step:</p>
            <div className="options">
              <div className="option">
                <div className="option-header">
                  <img src="assets/images/checkbox-green.png" alt="Checkmark" className="option-icon" />
                  Option 1: Buy Online & Save
                </div>
                <div className="option-details">
                  <ul>
                    <li>Get your first month of [Medication Name]</li>
                    <li>Use promo code [QUIZ20] to get 20% off today</li>
                    <li>No appointment required – we'll ship discreetly</li>
                  </ul>
                  <button className="btn-primary" onClick={() => window.open("https://injectco.store.prospyrmed.com/products/ship-to-home-semaglutide-5ml/05cbe365-288c-4b2c-bf61-0438f8c9efce","_blank")}>Buy Now with 20% Off</button>
                </div>
              </div>
              <div className="option">
                <div className="option-header">
                  <img src="assets/images/checkbox-green.png" alt="Checkmark" className="option-icon" />
                  Option 2: Talk to a Medical Expert
                </div>
                <div className="option-details">
                  <p>Not sure if this is right for you? Book a free consultation and we'll automatically share your quiz responses with one of our InjectCo nurses to speed things up.</p>
                  <button className="btn-primary" onClick={() => window.open("https://injectco.com/free-15-minute-virtual-consultation", "_blank")}>
                    Book Your Free Consultation
                  </button>
                </div>
              </div>
            </div>
          </div>

          <p style={{ marginTop: 20, marginBottom: 30, fontStyle: "italic" }}>We'll review your goals, answer your questions, and help customize your plan.</p>

          <section className="testimonial-block">
            <img src="/assets/images/share-page-img.webp" alt="Testimonial from Rachel" className="testimonial-image-display" />
            <div className="testimonial-quote-content">
              <p>"I lost 22 lbs in 2.5 months with Semaglutide. I've tried everything — this is the only thing that worked."</p>
              <span>– Diana M., 52</span>
            </div>
          </section>
          {/* 
          <section className="share-section">
            <h3>
              <img style={{ width: 20, verticalAlign: "middle", marginRight: 5 }} src="/assets/images/checkbox-green.png" alt="Checkmark" />
              Share your match with friends
            </h3>
            <p style={{ fontStyle: "italic" }}>I just took InjectCo's weight loss quiz and matched with {medicationName}! Find out your match in 60 seconds!</p>

            <div className="social-sharing">
              <button onClick={shareOnFacebook} className="share-button facebook">
                Share on Facebook
              </button>
              <button onClick={shareOnTwitter} className="share-button twitter">
                Tweet Your Results
              </button>
              <button onClick={shareOnWhatsapp} className="share-button whatsapp">
                Share on WhatsApp
              </button>
              <button onClick={copyLink} className="share-button link">
                Copy Link
              </button>
            </div>
          </section> */}

          <section className="final-cta-section">
            <p className="urgency-message-text">Live Answer | 8AM- 8PM | 7 days</p>
            <a href="tel:+18172142610" className="btn-primary call-btn">
              (817) 214-2610
            </a>
          </section>
        </main>
      </div>
      <Alert ref={alertRef} />
    </>
  );
}

export default SharePage;
